export default (byte) => (byte / 1048576).toFixed(0);
